export const enum Locale {
  Nl = 'nl',
  Fr = 'fr',
  En = 'en',
  De = 'de',
}

export const locales = [Locale.De, Locale.Nl, Locale.Fr, Locale.En];

export const defaultLocale = Locale.Nl;
